import { ComplexValue } from 'app/types-shared';
import { filterId } from 'app/area/search-filters/constants';
import {
  serializeCodes, serializePredefined
} from 'app/area/search-filters/serialize/serialize';
import { SerializePayload } from 'app/area/search-filters/types';
import { FilterSearchModel, SerializeCodes } from 'app/area/search-filters/types-store';
import { queryFilters, extraInfoPrefix } from '../constants';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ExtraInfoObject } from 'app/area/administration/list/types-store';
import { ExtraInfoFilterId } from 'app/area/administration/shared/types';

export const serializeQuery = (query: string, value: ComplexValue<number | string>[]) => {
  const searchInName = (value || []).some(v => v.value === queryFilters.name);
  const searchInPersonId = (value || []).some(v => v.value === queryFilters.id);
  const searchInAlternativeId = (value || []).some(v => v.value === queryFilters.alternativeId);
  const searchInAlternativeName = (value || []).some(v => v.value === queryFilters.alternativeName);
  const searchInEmail = (value || []).some(v => v.value === queryFilters.email);

  return query && query.trim().length &&
    (searchInName || searchInPersonId || searchInAlternativeId || searchInAlternativeName || searchInEmail)
    ? {
      [filterId.query]: {
        text: query.trim(),
        ...(!!value && {
          searchInName,
          searchInPersonId,
          searchInAlternativeId,
          searchInAlternativeName,
          searchInEmail
        })
      }
    }
    : {};
};

export const serializeExtraInfo = (serializedFilters: SerializeCodes): { [key: string]: ExtraInfoObject[] } => {
  const additionalInformation = Object.keys(serializedFilters).map(filter => {
    const splitedValues = filter.split('_');
    const prefix = splitedValues?.[0];
    const type = splitedValues?.[1];
    const id = parseInt(splitedValues?.[2], 10);

    return (prefix === extraInfoPrefix && isDefinedIncludingZero(id) && !!type) ? {
      additionalInformation: id,
      [type]: type === ExtraInfoFilterId.string ? {
        ...serializedFilters[filter],
        text: (serializedFilters[filter].text as string)?.replace(/[\n\s]+/g, ' ')
      } : serializedFilters[filter]
    } : undefined;
  }).filter(f => !!f);

  return additionalInformation?.length > 0 ? { additionalInformation } : {};
};

export const serialize = (dataToSerialize: SerializePayload): FilterSearchModel => {
  const { query, queryValues, formValues, menuValues, filters, filterValidation } = dataToSerialize;

  const extraInfoFilters = filters.filter(item => item.group === extraInfoPrefix);
  const defaultFilters = filters.filter(item => !isDefinedIncludingZero(item.group));

  return {
    ...serializeQuery(query, queryValues),
    ...serializePredefined(formValues),
    ...serializeCodes(formValues, menuValues, defaultFilters, filterValidation),
    ...serializeExtraInfo(serializeCodes(formValues, menuValues, extraInfoFilters, filterValidation))
  };
};
